import * as React from 'react'
import throttle from 'src/utils/throttle'

import styles from './index.scss'

const arrowImg = require('./assets/arrow.png')
interface IMenu {
  label: string
  path?: string
  children?: Required<IMenu[]>
}
interface IProps {
  height: string
  data: IMenu[]
  history: any
  show: boolean
  handleShowNav: () => void
}
class Collapse extends React.Component<IProps> {
  public listRef: React.RefObject<HTMLUListElement>
  public maskWrapper: React.RefObject<HTMLDivElement>
  public constructor(props: IProps) {
    super(props)
    this.maskWrapper = React.createRef()
    this.listRef = React.createRef()
  }
  public componentDidMount() {
    this.banMove()
  }
  public componentWillReceiveProps(nextProps: IProps) {
    if (!nextProps.show) {
      setTimeout(this.initCollapse, 300)
    } else {
      this.initCollapse()
    }
  }
  public preventDefault = (e: MouseEvent) => {
    e.preventDefault()
  }
  public banMove = () => {
    if (this.maskWrapper.current) {
      this.maskWrapper.current.addEventListener(
        'touchmove',
        this.preventDefault
      )
    }
  }
  public toggleNav = () => {
    this.props.handleShowNav()
    setTimeout(this.initCollapse, 300)
  }
  public handleToggle = (evt: React.MouseEvent) => {
    const arrow = evt.currentTarget.firstElementChild!.querySelector('img')!
    const subList = evt.currentTarget.querySelector('ul')
    const ele = evt.target as HTMLElement
    if (ele.nodeName === 'LI' || ele.nodeName === 'A') {
      return
    }
    if (!subList) {
      return
    }
    const isExpanded = JSON.parse(subList.getAttribute('data-expanded')!)
    const childLen = subList.childNodes.length
    if (!isExpanded) {
      subList.style.height = childLen * Number(this.props.height) + 'rem'
      arrow.style.transform = 'rotate(0deg)'
      this.setAttribute(subList, 'true')
      this.setAttribute(arrow, 'true')
    } else {
      subList.style.height = 0 + 'px'
      arrow.style.transform = 'rotate(180deg)'
      this.setAttribute(subList, 'false')
      this.setAttribute(arrow, 'false')
    }
  }
  public initCollapse = () => {
    if (!this.listRef.current) {
      return
    }
    const list = this.listRef!.current.childNodes
    // console.log(list)
    Array.from(list).forEach((item: HTMLElement, index: number) => {
      if (item.childNodes[0] && item.childNodes[1]) {
        // console.log(item.children)
        const [actionCon, subListCon] = Array.from(
          item.children
        ) as HTMLElement[]
        const arrowEle = actionCon.querySelector('img')
        // const childLen = subListCon.childNodes.length
        if (!arrowEle) {
          return
        }
        if (index === 0 || index === 1) {
          subListCon.style.height = 0 + 'rem'
          this.setAttribute(subListCon, 'false')
          arrowEle.style.transform = 'rotate(180deg)'
          this.setAttribute(arrowEle, 'false')
          setTimeout(() => {
            subListCon.style.transition = 'height .3s ease'
          }, 0)
        }
      }
    })
  }
  public handleLink = (path?: string) => {
    if (path) {
      this.props.history.push(path)
      this.toggleNav()
    }
  }
  public setAttribute = (
    ele: HTMLElement,
    val: string,
    attr = 'data-expanded'
  ) => {
    ele.setAttribute(attr, val)
  }
  public render() {
    const scrollTop =
      document.documentElement.scrollTop ||
      window.pageYOffset ||
      document.body.scrollTop
    const top = `calc(1.12rem - ${scrollTop}px)`
    const height = `calc(100% - 1.12rem + ${scrollTop}px)`
    return (
      <div
        ref={this.maskWrapper}
        className={styles.container}
        style={
          this.props.show
            ? {
                width: '100%',
                top,
                height
              }
            : { top }
        }
      >
        <div
          className={styles.mask}
          onClick={this.toggleNav}
          style={
            this.props.show
              ? {
                  height,
                  opacity: 0.3,
                  transition: 'none'
                }
              : {}
          }
        />
        <ul
          className={styles.list}
          ref={this.listRef}
          style={
            this.props.show
              ? {
                  height,
                  transform: 'translateX(0%)',
                  boxShadow: '-2px 0 8px rgba(1,1,1,0.5)'
                }
              : {}
          }
        >
          {this.props.data.map((item, index) => (
            <React.Fragment key={index}>
              {item.path ? (
                <li
                  style={{
                    lineHeight: `${this.props.height}rem`
                  }}
                  onClick={() => {
                    this.handleLink(item.path)
                  }}
                >
                  <div className={styles.title}>
                    {item.label}
                    {item.children && (
                      <img
                        src={arrowImg}
                        alt=""
                        className={styles.arrow}
                        data-expanded="false"
                      />
                    )}
                  </div>
                  {item.children ? (
                    <ul className={styles.sub_list} data-expanded="false">
                      {item.children.map((subItem, subIndex) => {
                        return (
                          <li
                            key={subIndex}
                            style={{
                              lineHeight: `${this.props.height}rem`
                            }}
                            onClick={() => {
                              if (subItem.path) {
                                this.props.history.push(subItem.path)
                                this.toggleNav()
                              }
                            }}
                          >
                            {subItem.label}
                          </li>
                        )
                      })}
                    </ul>
                  ) : null}
                </li>
              ) : (
                <li
                  style={{
                    lineHeight: `${this.props.height}rem`
                  }}
                  onClick={throttle(this.handleToggle, null, 300)}
                >
                  <div className={styles.title}>
                    {item.label}
                    {item.children && (
                      <img
                        src={arrowImg}
                        alt=""
                        className={styles.arrow}
                        data-expanded="false"
                      />
                    )}
                  </div>
                  {item.children ? (
                    <ul className={styles.sub_list} data-expanded="false">
                      {item.children.map((subItem, subIndex) => {
                        return (
                          <li
                            key={subIndex}
                            style={{
                              lineHeight: `${this.props.height}rem`
                            }}
                            onClick={() => {
                              if (subItem.path) {
                                this.props.history.push(subItem.path)
                                this.toggleNav()
                              }
                            }}
                          >
                            {subItem.label}
                          </li>
                        )
                      })}
                    </ul>
                  ) : null}
                </li>
              )}
            </React.Fragment>
          ))}
        </ul>
      </div>
    )
  }
}

export default Collapse



// WEBPACK FOOTER //
// ./src/components/Collapse/index.tsx